import { Sparkles } from "lucide-react";

const FAMILY_STYLE = {
  claude: {
    label: "Claude",
    bg: "bg-[#F5EEE4]",
    text: "text-[#7A4F2C]",
    border: "border-[#E8D8C1]",
  },
  gemini: {
    label: "Gemini",
    bg: "bg-[#E3EEFB]",
    text: "text-[#204E8A]",
    border: "border-[#C4D9F1]",
  },
};

/**
 * Small "answered by <model>" pill shown next to any AI-generated content
 * (Copilot turn, Family Story article, categorized email).
 *
 * Props:
 *   model_used?: { key, label, family: "claude" | "gemini", provider, model }
 *   size?: "sm" | "xs"  (default "xs")
 */
export default function AnsweredByPill({ model_used, size = "xs", className = "" }) {
  if (!model_used?.label) return null;
  const style = FAMILY_STYLE[model_used.family] || FAMILY_STYLE.claude;
  const px = size === "sm" ? "px-2.5 py-1 text-[11px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`answered-by-${model_used.family || "unknown"}`}
      title={`Model: ${model_used.provider || ""} / ${model_used.model || ""}`}
      className={`inline-flex items-center gap-1 rounded-full border ${style.bg} ${style.text} ${style.border} uppercase tracking-widest font-semibold ${px} ${className}`}
    >
      <Sparkles className="w-2.5 h-2.5" />
      Answered by {model_used.label}
    </span>
  );
}
